
import './App.css';
import HomeFour from './home/HomeFour';
import About from './inner/About';
import Service from './inner/Service';
import BusinessFormation from './inner/BusinessFormation';
import PayrollManagement from './inner/PayrollManagement';
import BookKeeping from './inner/BookKeeping';
import Tax from './inner/tax';
import BussinessConsultation from './inner/BussinessConsultation';
import Contact from './inner/Contact';
import NotFound from './inner/404';



import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';

import LoadTop from './components/LoadTop';
import BackTop from './components/BackTop';
import CurrentLink from './components/CurrentLink';
// import Preloader from './components/Preloader';

function App() {

  
  return (
    <div className="App">

      <Router>

        <LoadTop />
        <CurrentLink />
        <BackTop />
        
        {/* <Preloader /> */}

        <Routes>
          <Route path="/" element={<HomeFour/>}> </Route>
         
          <Route path="/About" element={<About/>}> </Route>
          <Route path="/Service" element={<Service/>}> </Route>
          <Route path="/Business-Formation" element={<BusinessFormation/>}> </Route>
          <Route path="/payroll-management" element={<PayrollManagement/>}> </Route>
          <Route path="/book-keeping" element={<BookKeeping/>}> </Route>
          <Route path="/tax" element={<Tax/>}> </Route>
          <Route path="/business-consultation" element={<BussinessConsultation/>}> </Route>
          <Route path="/contact-us" element={<Contact />}> </Route>
          <Route path="*" element={<NotFound />} />
          
          
        </Routes>
      </Router>

    </div>
  );
}

export default App;


